import Link from '@material-ui/core/Link';
import styled from "styled-components"


export const FooterLink = styled(Link)`
  color:white;
  font-size: 0.8rem;
  margin:${props => props.theme.spacing(2)}px;
`